import './hero.css';

import { useNavigate
 } from 'react-router-dom';
import heroImage from '../../images/heroIMg.png';

import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';

function Hero() {
  const navigate = useNavigate();

  const handleButton = () => {
    navigate('/cardapio');
  }

  return (
      <div className="heroContainer">
        <h2>Promoção!!</h2>
        <h3>50 mini pizzas pré assadas por apenas </h3>
        <img src={heroImage} alt="" />
        <div className="buttonContainer">
          <button onClick={handleButton}>Cardápio</button>
        </div>
        <div className="deliveryContainer">
          <h3>Fazemos entrega!! <i><DeliveryDiningIcon /></i></h3>
          <p>(Consultar valor de frete)</p>
        </div>
      </div>
    );
}

export default Hero;